import Utils from "../../services/Utils.js";
import { getGames } from "../../js/api/gameByLeagues.js";
import { getGameTemplate } from "../templates/game.js";

import {sports} from "../components/Leftpanel.js";
import {leagues} from "./League.js";
import { _t } from "../../services/TranslationService.js";


var leagueId = 0;
let Games = {
  render: async () => {
    let request = Utils.parseRequestURL();
    leagueId = request.id;

    let games = await getGames(request.id);
    const uniqueDates = [
      ...new Set(games.map((item) => item.game_date)),
    ].sort();

    let sportName = games[0].sport;
    let countryName = games[0].country;
    let leagueName = games[0].league;
    let columns = '';
    try {
      columns = games[0].odd.split(',').length == 2 ? 'twoColumn' : '';
    } catch {}


    let sportsView = '';
    sports.forEach((sport) => {
      sportsView = sportsView + `<a href="#/categories/${sport.id}" class="betModuleSportBtn active hd-${sport.name}">
                       <i class="sport-${sport.name}"></i>
                       <span>${_t(sport.name)}</span>
                     </a>`
    });

    console.log(games);
    let gamesView = "";

    uniqueDates.forEach((date) => {
      let singleDateView = "";

      games
        .filter((a) => a.game_date === date)
        .map((game) => {
          if(!game.odd){
            return;
          }
          singleDateView += getGameTemplate(game);
        });

      gamesView =
        gamesView +
        ` <div class="gameTableContent">
                <div class="singleGameDateLabel">
                   <span>${date}</span>
                   <span>1</span>
                   <span>X</span>
                   <span>2</span>
                </div>
                <div>
                  ${singleDateView}
                </div>
            </div>`;
    });

    if (gamesView === "") {
      gamesView = `<h3>${_t('Ska loje')}</h3>`;
    }
    // let posts = await getPostsList()
    let view = /*html*/ `
            <div class="pageHeaderTitle">
                <a class="backBtn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                </a>
                <span>${sportName} / ${countryName} - ${leagueName}</span>
            </div>
            <div class="gameTableHeader m-t-6">
                <span class="gameTableHeaderTitle">${games[0].league}</span>
            </div>
            <div id="pre-match-games" class="${columns}">
              <div class="gameTableContent">
                  ${gamesView}
              </div>
            </div>
       `;
    return view;
  },
  after_render: async (socket) => {
    socket.emit('connectToRoom', {room: "prematch-games"});
    socket.on("new-game", (data) => {
      if (data.league == leagueId) {
        const game = document.getElementById(data.id);

        if (!game) {
          let liveGameContainer = document.getElementById("pre-match-games");
          if (liveGameContainer) {
            const template = getGameTemplate(data);
            liveGameContainer.innerHTML =
              liveGameContainer.innerHTML + template;
          }
        } else {
          game.innerHTML = getGameTemplate(data);
        }
      }
    });
  },
  on_unload : async (socket) => {
    socket.emit('leaveRoom', {room: "prematch-games"});
  },
};

export default Games;
